function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0b543;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 47,
  cy: 47,
  r: 47
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M328.4,550.307H325a2.554,2.554,0,0,1-2.554-2.554V532.429A2.554,2.554,0,0,1,325,529.875H328.4a2.554,2.554,0,0,1,2.554,2.554v15.324A2.554,2.554,0,0,1,328.4,550.307Z",
  transform: "translate(-297.58 -477.767)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M352.242,550.307h-3.405a2.554,2.554,0,0,1-2.554-2.554v-25.54a2.554,2.554,0,0,1,2.554-2.554h3.405a2.554,2.554,0,0,1,2.554,2.554v25.54A2.554,2.554,0,0,1,352.242,550.307Z",
  transform: "translate(-297.58 -477.767)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M364.16,550.307h-3.405a2.554,2.554,0,0,1-2.554-2.554V510.295a2.554,2.554,0,0,1,2.554-2.554h3.405a2.554,2.554,0,0,1,2.554,2.554v37.458a2.554,2.554,0,0,1-2.554,2.554Z",
  transform: "translate(-297.58 -477.767)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M340.323,550.307h-3.405a2.554,2.554,0,0,1-2.554-2.554V501.781a2.554,2.554,0,0,1,2.554-2.554h3.405a2.554,2.554,0,0,1,2.554,2.554v45.972a2.554,2.554,0,0,1-2.554,2.554Z",
  transform: "translate(-297.58 -477.767)"
});

function SvgIconMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMission);
export default __webpack_public_path__ + "static/media/icon_mission.055ffcc6.svg";
export { ForwardRef as ReactComponent };